<template>
  <div id="vip">
    <van-row class="vip_shop">
      <van-col span="22" offset="1">
        <van-col span="24" v-for="(l) in vip_task_list" :key="l.id" class="vip_task_type">
          <van-col span="10" class="vip_task_type_title">{{ l.title }}</van-col>
          <van-col span="7" class="vip_task_type_sum">{{ $t('column.Growth_value')}}+{{ l.sum }}</van-col>
          <van-col span="7" class="vip_task_type_btn">
            <van-button class="vip_task_type_btn_color vip_complete_color" v-if="l.status">{{ $t('column.Completed')}}</van-button>
            <van-button class="vip_task_type_btn_color" v-else>{{ $t('column.not_finished')}}</van-button>
          </van-col>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>

<script>

  import '@/assets/css/style.css'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Dialog, Progress, Tab, Tabs } from 'vant'
  export default {
    data() {
      return {
        vip_task_list: []
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.vip_task')
    },
    components: {
      [Dialog.name]: Dialog,
      [Progress.name]: Progress
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vip_grade&act=task_list", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.vip_task_list = res.data.data
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vip_task.vue